import {assert} from 'Asserts';
import {Request, RequestSchema} from 'requests/RequestConstants';
import {RequestTask, RequestTaskSchema} from 'requests/tasks/RequestTaskConstants';
import ErrorSubclass from 'util/ErrorSubclass';
import {Optional} from 'util/Types';
import {SampleGroup} from 'workflows/WorkflowConstants';

import {RequestFulfillment} from './FulfillmentConstants';
import {HydratedFulfillment} from './HydratedFulfillmentConstants';

export class MissingDataError extends ErrorSubclass {}

function getRequiredFromMap<T>(id: Optional<string>, objsById: {[id: string]: T}): T {
  assert(id != null, 'id should not be null');
  if (objsById[id]) {
    return objsById[id];
  } else {
    throw new MissingDataError();
  }
}

function getOptionalFromMap<T>(id: Optional<string>, objsById: {[id: string]: T}): Optional<T> {
  return id != null ? getRequiredFromMap(id, objsById) : null;
}

export default function hydrateFulfillmentInputs(
  fulfillments: Array<RequestFulfillment>,
  requestsById: {[requestId: string]: Request},
  sampleGroupsById: {[sampleGroupId: string]: SampleGroup},
  tasksById: {[taskId: string]: RequestTask},
  requestSchemasById: {[schemaId: string]: RequestSchema},
  taskSchemasById: {[schemaId: string]: RequestTaskSchema}
): Array<HydratedFulfillment> {
  return fulfillments.map((fulfillment) => {
    assert(
      fulfillment.requestId != null,
      `fulfillment.requestId should not be null. fulfillment.id=${fulfillment.id}`
    );
    const request = getRequiredFromMap(fulfillment.requestId, requestsById) || null;
    const requestTask = getOptionalFromMap(fulfillment.requestTaskId, tasksById) || null;
    const sampleGroup = getOptionalFromMap(fulfillment.sampleGroupId, sampleGroupsById) || null;
    return {
      fulfillment,
      request,
      sampleGroup,
      requestTask,
      requestSchema: getRequiredFromMap(request.schemaId, requestSchemasById),
      requestTaskSchema: requestTask && getRequiredFromMap(requestTask.schemaId, taskSchemasById),
    };
  });
}
